export default __webpack_public_path__ + "static/media/advance-bookings.c257f56b.svg";